import React from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import PropTypes from 'prop-types'

import Pagination from 'app/components/Pagination/Pagination'
import NoCompletedProtracks from 'app/components/NoActivitiesComponent'
import SectionHeader from 'app/components/SectionHeader'
import LevelItem from './LevelItem/index'
import CompletedProTracksLoader from 'app/domains/common/Loaders/FavoriteActivitiesLoader'

import './style.scss'
const baseClass = 'completed-levels'

const CompletedProTracks = ({ t, levels, totalPages, currentPage, onSelectPage, pending, showPaginate }) => (
  <div className={baseClass}>
    <SectionHeader className={`section-header--${baseClass}`} backHref title={t('Completed ProTracks')} />
    <div className={`${baseClass}__body`}>
      {pending ? (
        <CompletedProTracksLoader />
      ) : levels.size ? (
        levels.map(level => <LevelItem key={level.get('id')} proTrackId={level.get('id')} {...level.toJS()} />)
      ) : (
        <NoCompletedProtracks topText={t('You have no completed ProTracks yet')} customClass="completed-protracks" />
      )}
    </div>
    {showPaginate && (
      <div className={`${baseClass}__footer`}>
        <Pagination
          pageCount={totalPages}
          onPageChange={({ selected }) => onSelectPage(selected)}
          initialPage={currentPage}
        />
      </div>
    )}
  </div>
)

CompletedProTracks.propTypes = {
  levels: ImmutablePropTypes.list.isRequired,
  showPaginate: PropTypes.bool,
  onSelectPage: PropTypes.func,
  pending: PropTypes.bool,
  totalPages: PropTypes.number,
  currentPage: PropTypes.number,
}

export default CompletedProTracks
